/**
* 重定向到QIUI 官网
*/
<template>

	<div>首页</div>

</template>

<script>
	// document.addEventListener('DOMContentLoaded', function() {
	// 	window.open('https://www.qiuitoy.com/');
	// });



	export default {
		name: 'Home',
		mounted() {


			this.$router.push({
				//默认跳转到社区页面
				//path: 'community/198626/296358/zh/296358'
				//path: 'community/230514/497899',
				//path: 'community/198626/296358/296358'

				//默认跳转到社区玩具页面
				//path: 'communityToys/25129/296358'

				//path: 'communityToys/104512/273431'
				//path: 'communityToys/104583/264352'
				//path: 'communityToys/106609/266760' //二代锁公投页面
				//path: 'communityToys/107503/242190'//不允许游客投票的三代锁界面

				//默认跳转到商品详情
				//path: 'commodity/51'

				//默认跳转到注册页面
				//path: 'register'

				//跳转到下载页面
				//path: '/download'

				//删除账号
				//path: '/deleteAccount'


				// path: '/test'//默认跳转到测试页面
				//path: '/QIUIPrivacyPolicy' ,//隐私政策

				// path: '/VipExchange' //VIP兑换
				// path: '/AmapH5' //高德地图
				// path: 'gen3Country'//跳转到三代锁支持购买国家的页面
				path: 'VoiceRoom/db117f4ad340722d1ee6467bbed1cd2d/霸王龙' //直播间的分享

				//path: '/warehouse' //入库查询
				// path: '/WindControlHome' //风控首页
				// path: '/WindControlInfo' //风控详情
				// path: '/AfterSalesHome' ,//售后首页
				// path: '/AfterSalesInfo' //售后详情
				// path: '/AfterSalesAddHome', //添加售后首页
				// path: '/AfterSalesAdd' ,//添加售后



				//path: '/Home', //整个页面的首页
				//path: '/Login', //整个页面的登录

			});




		}
	}
</script>

<style>
</style>